const styles = {
    meterContent: {
        position: 'relative',
        height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
        padding: 2,
        boxSizing: 'border-box',
        backgroundColor: '#f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        gap: 2,
    },
};

export default styles;